import { useState } from 'react';

const defaultInput = {
  name: '',
  value: '',
};

const JsonStringifyTextGenerator = () => {
  const [inputs, setInputs] = useState([defaultInput]);
  const [output, setOutput] = useState('');

  const handleInputChange = (index, e) => {
    const newInputs = [...inputs];
    newInputs[index][e.target.name] = e.target.value;
    setInputs(newInputs);
  };

  

  const handleAddInput = () => {
    setInputs([...inputs, defaultInput]);
  };

  const handleRemoveInput = (index) => {
    const newInputs = [...inputs];
    newInputs.splice(index, 1);
    setInputs(newInputs);
  };

  const handleGenerate = () => {
    const obj = {};
    inputs.forEach((input) => {
      obj[input.name] = input.value;
    });
    const jsonString = JSON.stringify(obj, null, 4);
    setOutput(jsonString);
  };
  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy '); // State for button label


  const handleCopy = () => {
    navigator.clipboard.writeText(output);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };
 

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <div className="flex flex-col mb-4">
        {inputs.map((input, index) => (
          <div key={index} className="flex flex-row mb-2">
            <input
              type="text"
              name="name"
              value={input.name}
              onChange={(e) => handleInputChange(index, e)}
              placeholder="Key"
              className="form-control mb-4"            />
            <input
              type="text"
              name="value"
              value={input.value}
              onChange={(e) => handleInputChange(index, e)}
              placeholder="Value"
              className="form-control mb-4"            />
           
          </div>
        ))}
      
      </div>
      <button
        onClick={handleGenerate}
        className="btn btn-primary"
      >
        Generate
      </button>
      <div className="flex flex-col mt-4">
        <textarea
          value={output}
          rows={10}
          readOnly
          className="form-control mb-4"           
        /></div>
              <div className="d-flex  align-items-center mb-4">

        <button
          onClick={handleCopy}
          className="btn btn-primary"
        >
           {copyButtonLabel}
        </button>

      
        </div>
      
      
    </div>
  );
};

export default JsonStringifyTextGenerator;